import React, { useEffect, useState } from "react";

// Aviso de versión nueva: si se publicó un deploy mientras el sistema estaba abierto, la
// pestaña sigue corriendo el código viejo (pasó en VentaDirecta: totales en $0). Se compara
// el main.<hash>.js cargado contra el del index.html publicado; si cambió, se pide recargar.
// No recarga solo para no perder lo que estén capturando. En desarrollo (npm start) no hace nada.
const REVISAR_CADA_MS = 5 * 60 * 1000;
const patron = /\/static\/js\/main\.[a-z0-9]+\.js/;

const scriptCargado = () => {
  const s = Array.from(document.scripts)
    .map((x) => x.src || "")
    .find((src) => patron.test(src));
  return s ? s.match(patron)[0] : null;
};

function VersionNueva() {
  const [hayNueva, setHayNueva] = useState(false);

  useEffect(() => {
    const actual = scriptCargado();
    if (!actual) return undefined; // desarrollo: no hay bundle con hash
    let cancelado = false;

    const revisar = async () => {
      if (cancelado || document.hidden) return;
      try {
        const resp = await fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" });
        if (!resp.ok) return;
        const m = (await resp.text()).match(patron);
        if (m && m[0] !== actual && !cancelado) setHayNueva(true);
      } catch (e) {
        // sin red: se vuelve a intentar en la siguiente revisión
      }
    };

    const intervalo = setInterval(revisar, REVISAR_CADA_MS);
    const alVolver = () => {
      if (!document.hidden) revisar();
    };
    document.addEventListener("visibilitychange", alVolver);
    window.addEventListener("focus", alVolver);
    return () => {
      cancelado = true;
      clearInterval(intervalo);
      document.removeEventListener("visibilitychange", alVolver);
      window.removeEventListener("focus", alVolver);
    };
  }, []);

  if (!hayNueva) return null;
  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "#f59e0b",
        color: "#1f2937",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        flexWrap: "wrap",
        fontWeight: 600,
        boxShadow: "0 2px 8px rgba(0,0,0,.2)",
      }}
    >
      <span>
        <i className="fas fa-sync-alt" style={{ marginRight: 8 }} />
        Hay una versión nueva del sistema. Termina o guarda lo que estés capturando y recarga la página.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          background: "#1f2937",
          color: "#fff",
          border: "none",
          borderRadius: 20,
          padding: "6px 16px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Recargar ahora
      </button>
    </div>
  );
}

export default VersionNueva;
